import { PensionPlanType } from '/@/modules/asset/enums/PensionPlanType';

export class PensionPlanAssetMeta {
  /**
   * @var {string}
   */
  pensionPlanProviderId;

  /**
   * @var {PensionPlanProvider}
   */
  pensionPlanProvider;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {number};
   */
  sharePercentage;

  constructor(model) {
    this.pensionPlanProvider = model.pensionPlanProvider;
    this.pensionPlanProviderId = model.pensionPlanProviderId || null;
    this.type = model.type;
    this.sharePercentage = model.sharePercentage;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return `${this.pensionPlanProvider.name} ${PensionPlanType.getByKey(this.type)?.value}`;
  }
}
